export enum Setting {
	SHOW_VACATION_REMINDER = 'SHOW_VACATION_REMINDER'
}
